import {useTranslation} from "react-i18next";
import {useField, useFormikContext} from "formik";
import PropTypes from "prop-types";

import saveImg from "../../images/icons/save.png";
import delImg from "../../images/icons/trash.png";
import ToolTip from "../../utilities/ToolTip";
import useRoutePermissions, {
  UI_PERMISSION_TYPE,
} from "../adminForms/Ba3aSettings/tabs/PositionsSettings/useRoutePermissions";

import "./utils/Inputs.scss";

const TextAreaInput = ({
  label,
  width,
  areaWidth = "100%",
  height,
  areaHeight,
  id,
  action = false,
  className = "",
  inputClassName = "",
  style,
  labelWrap,
  placeholder = "",
  setref,
  required,
  onBlur = () => {},
  readOnly = false,
  disabled = false,
  tooltipMessage = null,
  bottomTooltip = false,
  noFunctional = false,
  isRequiredAccented = true,
  uiPermissionType = UI_PERMISSION_TYPE.WRITABLE,

  ...props
}) => {
  const {t} = useTranslation();

  const [field, meta] = useField(props);
  const {setFieldValue} = useFormikContext();

  const trimValue = v => (typeof v === "string" ? v.trim() : v);

  const delAll = () => {
    setFieldValue(field.name, "");
  };

  const styles = {
    width,
    height,
    ...style,
  };

  const onBlurHandler = e => {
    const trimmed = trimValue(e?.target?.value);
    if (trimmed !== e?.target?.value) {
      setFieldValue(field.name, trimmed);
    }

    if (typeof field?.onBlur === "function") {
      field.onBlur(e);
    }

    onBlur(e, trimmed);
  };

  const labelText = label ? t(label) : "";
  const isRequiredMarkHighlighted = !field.value && !readOnly && !noFunctional && !disabled;

  const {isDisabledByRoutePermission} = useRoutePermissions({uiPermissionType});

  return (
    <ToolTip
      className={`project_input textereaInput ${className ?? ""} ${labelWrap ? "" : "labelWrap"}`}
      style={styles}
      id={id}
      title={
        noFunctional
          ? "No functional"
          : isDisabledByRoutePermission && !readOnly && !disabled
          ? "Your position has no permission for this action"
          : tooltipMessage
      }
      bottom={bottomTooltip}
    >
      <>
        {Boolean(label) || Boolean(action) ? (
          <div className="flex_container" style={{justifyContent: "space-between"}}>
            {label && (
              <label className="textArea_label" htmlFor={props.name}>
                <span>
                  {labelText}
                  {required && (
                    <span className={isRequiredAccented && isRequiredMarkHighlighted ? "required-asterisk" : ""}>
                      *
                    </span>
                  )}
                  :
                </span>
              </label>
            )}
            {action ? (
              <div className="">
                <img src={saveImg} alt="" draggable="false" />
                <img src={delImg} alt="" onClick={delAll} draggable="false" />
              </div>
            ) : null}
          </div>
        ) : null}
        <textarea
          {...props}
          {...field}
          className={inputClassName}
          value={field.value || ""}
          style={{
            width: areaWidth,
            height: areaHeight,
            cursor: readOnly || noFunctional || isDisabledByRoutePermission ? "default" : "text",
            ...(readOnly || noFunctional || disabled || isDisabledByRoutePermission
              ? {background: "transparent"}
              : {background: "white"}),
          }}
          placeholder={t(placeholder) + (!label && required ? "*" : "")}
          ref={setref}
          onBlur={onBlurHandler}
          readOnly={readOnly}
          disabled={isDisabledByRoutePermission || disabled || noFunctional}
        />
        {meta.touched && meta.error ? <div className="error">{meta.error}</div> : null}
      </>
    </ToolTip>
  );
};

TextAreaInput.propTypes = {
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.element, PropTypes.node]),
  width: PropTypes.string,
  areaWidth: PropTypes.string,
  height: PropTypes.string,
  id: PropTypes.string,
  action: PropTypes.bool,
  className: PropTypes.string,
  inputClassName: PropTypes.string,
  disabled: PropTypes.bool,
  placeholder: PropTypes.string,
  readonly: PropTypes.bool,
  props: PropTypes.array,
};

export default TextAreaInput;
